import { useTheme } from '@emotion/react'

import {
  ArduinoMonoLogo,
  CrossFitMonoLogo,
  IbmMonoLogo,
  MongoDbMonoLogo,
  UnivisionMonoLogo,
} from '@segment/matcha/components/CompanyLogos/CompanyMono'
import {
  ArduinoLogo,
  CrossFitLogo,
  IbmLogo,
  MongoDbLogo,
  UnivisionLogo,
} from '@segment/matcha/components/CompanyLogos/Company'

const testimonialData = () => {
  const theme = useTheme()
  return [
    {
      company: `ibm`,
      text: (
        <>
          “With real-time integrated data flows from Segment, we can truly{` `}
          <mark>understand what people are doing</mark>
          {` `}
          with our platform.”
        </>
      ),
      logo: <IbmMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <IbmLogo />,
      logoName: `Ibm`,
    },
    {
      company: `mongodb`,
      text: (
        <>
          “Since implementing Segment we have seen a significant increase in revenue which we attribute to the{` `}
          <mark>improved targeting and personalization of our communications</mark>.“
        </>
      ),
      name: `Ale Dimitriu`,
      position: `Senior Marketing Operations Manager, MongoDB`,
      logo: <MongoDbMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <MongoDbLogo />,
      logoName: `mongodb`,
      extendedRate: `100x`,
      extendedText: `increased registration rates`,
      extendedLink: `/customers/mongodb/`,
    },
    {
      company: `univision`,
      text: (
        <>
          “Regardless of scale, Segment provides you the tools and platform to move quickly and efficiently. We couldn’t
          have done this any other way.“
        </>
      ),
      name: `Jay Iyer`,
      position: `Vice President of Data Engineering`,
      logo: <UnivisionMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <UnivisionLogo />,
      logoName: `univision`,
      extendedRate: `3 months`,
      extendedText: `to launch streaming service`,
      extendedLink: `/customers/univision/#launching-vix-with-twilio-segment-as-the-data-layer`,
    },
    {
      company: `crossfit`,
      text: (
        <>
          “Now, our data and teams are cohesive and connected, we can make data driven decisions and reach our customers
          effectively.“
        </>
      ),
      name: `Jay Meyering`,
      position: `Senior Software Development Manager `,
      logo: <CrossFitMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <CrossFitLogo />,
      logoName: `crossfit`,
      extendedRate: `30%`,
      extendedText: `More efficient with Engineering resources`,
      extendedLink: `/customers/crossfit/`,
    },
    {
      company: `arduino`,
      text: (
        <>
          “A big benefit of Segment is being able to activate our first-party data all in one platform. Our previous
          tool required more manual effort, and therefore limited our marketing communication options“
        </>
      ),
      name: `Alice Luzzi`,
      position: `Digital Marketing Specialist`,
      logo: <ArduinoMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <ArduinoLogo />,
      logoName: `arduino`,
      extendedRate: `70%`,
      extendedText: `increased accuracy of audience segments`,
      extendedLink: `/customers/arduino/`,
    },
  ]
}

export { testimonialData }
